import React from "react";

const Map = ()=>{
    return(
        <iframe title="park-linowy-mapa" id="gmap_canvas" src="https://maps.google.com/maps?q=53.50322543878745,%2019.756139947949148&t=&z=13&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
    )
}



export default Map;